<template>
  <div class="tenant">
    <CreateOrEditTenant ref="createOrEditDialog" @submitDialog="GetTableList" />

    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>认证企业</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="3">
          <label>企业名称</label>
          <el-input
            :placeholder="l('请输入') + l('内容')"
            v-model="SearchData.name"
            clearable
            @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <label>企业类型</label>
          <el-select
            v-model="SearchData.business_tag_id"
            clearable
            @change="GetTableList(true)"
          >
            <el-option
              v-for="item in $store.state.basicInfo.tagList.business_1"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="3">
          <label>信用状态</label>
          <el-select
            clearable
            v-model="SearchData.credit_rating"
            @change="GetTableList(true)"
          >
            <el-option
              v-for="item of $store.state.basicInfo.credit_ratingList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>

        <el-col :span="3">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            @click="GetTableList(true)"
            >{{ l("查询") }}</el-button
          >
        </el-col>
      </el-row>

      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <TableOperation
          :operationList="[
            {
              is_show: (row) =>
                this.$store.getters.checkPermission('admin_tenant.edit'),
              label: l('详情'),
              command: 'ViewItem',
            },
          ]"
          @handleOperation="HandleOperation"
        />

        <el-table-column
          prop="name"
          label="企业名称"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          :label="l('企业类型')"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{
              $utils.listFilter(
                $store.state.basicInfo.tagList.business_1,
                scope.row.business_tag_id
              )
            }}
          </template>
        </el-table-column>

        <el-table-column label="用户数" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link
              type="warning"
              @click="viewUser(scope.row)"
            >
              {{ scope.row.user_count }}
            </el-link>
          </template>
        </el-table-column>

        <el-table-column label="信用状态" width="100">
          <template slot-scope="scope">
            <div>
              <el-select
                v-model="scope.row.credit_rating"
                size="mini"
                :disabled="!$store.getters.checkPermission('admin_tenant.edit')"
                @change="changeCreditRating(scope.row)"
              >
                <el-option
                  v-for="credit_rating of $store.state.basicInfo
                    .credit_ratingList"
                  :key="credit_rating.id"
                  :label="credit_rating.name"
                  :value="credit_rating.id"
                ></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_time"
          label="认证时间"
          sortable="custom"
          width="170"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditTenant from "./operation/CreateOrEditTenant.vue";

export default {
  name: "Tenant",
  components: {
    CreateOrEditTenant,
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        name: "",
        credit_rating: "", //0 1
      },
    };
  },
  created() {
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get(`/api/admin_tenant/`, {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    viewUser(item) {
      this.$router.push({ path: "/admin/user", query: { tenant_id: item.id } });
    },
    changeCreditRating(item) {
      this.$confirm(`是否修改【${item.name}】的信用状态?`, "", {
        type: "warning",
      })
        .then(() => {
          this.axios
            .put(`/api/admin_tenant/${item.id}/edit_credit_rating/`, {
              credit_rating: item.credit_rating,
            })
            .then((response) => {
              this.GetTableList();
            })
            .catch(() => {
              this.GetTableList();
            });
        })
        .catch(() => {
          this.GetTableList();
        });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

